import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import constant from '../../constant'
export default class ManageUserRightMenu extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="nav-side-menu">
            <i className="fa fa-bars fa-2x toggle-btn" data-toggle="collapse" data-target="#menu-content"></i>
            <div className="menu-list">
                <ul id="menu-content" className="menu-content collapse out">

                    <li data-toggle="collapse" data-target="#products" className="collapsed active">
                        <a href="javascript:void();"><i className="la la-briefcase fa-lg"></i> Manage Subusers <span className="arrow"></span></a>
                    </li>
                    <ul className="sub-menu collapse show" id="products">
                        {/* <Link to={constant.component.ManageSubusers.url} ><li className="active">User Update</li></Link> */}
                        <Link to={constant.component.UserCreate.url} ><li className="active">User Create</li></Link>
                        <Link to={constant.component.UserList.url} ><li className="active">User List</li></Link>
                    </ul>
                </ul>
            </div>
        </div>
    </React.Fragment>
    )
  }
}
